import i18n from './i18n';

export const FlashDefinition = {
  createSubmissionSuccess: {
    context: [{ detail: i18n.createSubmissionSuccess }],
    status: 'success',
  },
  createBulkSubmissionProcessing: {
    context: [{ detail: i18n.createBulkSubmissionProcessing }],
    status: 'info',
  },
  addCandidateToTearsheetSuccess: {
    context: [{ detail: i18n.addCandidateToTearsheetSuccess }],
    status: 'success',
  },
  addCandidateToTearsheetProcessing: {
    context: [{ detail: i18n.addCandidateToTearsheetProcessing }],
    status: 'info',
  },
  createTearsheetSuccess: {
    context: [{ detail: i18n.createTearsheetSuccess }],
    status: 'success',
  },
  createTearsheetError: {
    context: [{ detail: i18n.createTearsheetError }],
    status: 'error',
  },
  jobPrefillError: {
    context: [{ detail: i18n.jobPrefillError }],
    status: 'error',
  },
};
